import * as campaignsClient from 'lib/clients/fetchCampaign';
import { fetchCampaign, setCampaign, clearCampaign } from './campaignActions';
import { getTreatments } from 'store/split/splitSelectors';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import { createAsyncLogic } from 'lib/logic';

const fetchCampaignLogic = createAsyncLogic({
  type: fetchCampaign,
  latest: true,
  async process({ getState }, dispatch) {
    const campaign = await campaignsClient.fetchCampaign();

    if (!isEmpty(campaign)) {
      dispatch(setCampaign(campaign));
    } else {
      const { blue_banner_message: localCampaign } = getTreatments(getState());
      const localCampaignConfig = isEmpty(localCampaign) ? null : localCampaign.config;
      if (isObject(localCampaignConfig)) {
        dispatch(setCampaign(localCampaignConfig));
      } else {
        dispatch(setCampaign({}));
      }
    }
  },
  onError(context, dispatch) {
    dispatch(clearCampaign());
  },
});

export const logic = [fetchCampaignLogic];
